import { Typography } from '@mui/material';
import React from 'react';

import { useQuery } from '@apollo/react-hooks';
import { ListItem } from '../../shared/types';
import LinkList, { ListItemOrientation, ListItemType } from './LinkList';
import { GET_MONTHS_LIST } from '../../gql/articles';
import moment from 'moment';
import { baseUrls } from '../../utils/baseUrls.utils';

interface YearMonthExt {
    year: number;
    month: number;
    asDate?: moment.Moment;
}

export const Archives: React.FC = () => {
    const qryMonth = useQuery(GET_MONTHS_LIST, { fetchPolicy: 'network-only' });

    if (qryMonth.loading) return <></>;

    const loadedData: YearMonthExt[] =
        qryMonth?.data?.getLastMonthsWithArticles ?? [];

    const dataAsDate = loadedData.map((x) =>
        moment(new Date(x.year, x.month - 1, 1))
    );

    const recentArticles: ListItem[] = dataAsDate.map((date) => ({
        id: date?.format('YYYY-MM') ?? '-',
        name: date?.format('MMMM YYYY') ?? '-',
        url: `${baseUrls.archives.main}/${date?.format('YYYY-MM')}`,
    }));

    return (
        <div>
            <Typography sx={{ mb: 2 }} variant="h5">
                Archives
            </Typography>
            <div id={'articles-archive'}>
                <LinkList
                    disableSort
                    items={recentArticles}
                    orientation={ListItemOrientation.Vertical}
                    displayType={ListItemType.Link}
                    isSpacedVerticalLinks={true}
                />
            </div>
        </div>
    );
};

export default Archives;
